/**
 * Tells if a user access code (administrator, manager...) can perform an action on a resource.
 * Actions: C=8, R=4, U=2, D=1, V=16
 *
 * @param userAccessCode
 * @param action
 * @param resource
 * @returns {*|boolean}
 */
export default function can(userAccessCode, action, resource) {
  const data = !!window.keyprodpermissions.permissions[userAccessCode]
    && !!window.keyprodpermissions.permissions[userAccessCode][resource]
    // eslint-disable-next-line no-bitwise
    && (window.keyprodpermissions.permissions[userAccessCode][resource] & action) === action;

  return data;
}
